// @ts-ignore
import { watch } from 'vue'


export default function redirectsOnInCoverage(coverageCheckResult) {
    watch(coverageCheckResult, (newValue) => {
        if(newValue.value.in_coverage) {
            let network = newValue.value.ont_location ? 'fibre' : 'core';
            let lowUsage = newValue.value.show_low_usage_plan;

            let signupUrl = process.env.VUE_APP_SIGNUP_URL.endsWith('/')
                ? process.env.VUE_APP_SIGNUP_URL
                : process.env.VUE_APP_SIGNUP_URL + '/';
            let href = `${signupUrl + newValue.value.jwt}?network=${network}`;
            if(lowUsage){
                href += '&low_usage=1';
            }

            window.top.location.href = href;
        }
    })

    return {};
}
